import React, { PureComponent } from "react"
import "./main.styl"

interface Props {}

export default class CustomTitle extends PureComponent<Props> {
    render() {
        const { children } = this.props
        return <div className="custom-title">{children}</div>
    }
}
